import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import AdminDashboard from "./views/admin/AdminDashboard";

const adminRoot = document.getElementById("sh-lms-admin-root");
const clientRoot = document.getElementById("sh-react-root") || document.getElementById("root");

if (adminRoot) {
  createRoot(adminRoot).render(
    <StrictMode>
      <AdminDashboard onBack={() => { window.location.href = "/wp-admin/admin.php?page=shuddhoshikha-hub"; }} isDarkMode={false} />
    </StrictMode>
  );
} else if (clientRoot) {
  createRoot(clientRoot).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

